module.exports = __webpack_public_path__ + "img/fondo_series.24c0492e.jpg";